module.exports = __webpack_public_path__ + "static/Muli-Light.fb56401f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-Light.ttf
// module id = 337
// module chunks = 114276838955818